/* eslint-disable no-undef */
/* eslint-disable no-param-reassign */
import {
  makeType,
  parseOptions,
  initLog
} from '../core/base'

import UI from '../core/ui'
import APIChannel from '../core/api_channel'

// import { getWith, maybe, first, guard } from "../ui/core/functions"
// import { guard } from "../core/functions"

import {
  getWith,
  maybe,
  first,
  guard
} from '../core/functions'
import {
  Stream
} from '../core/dispatcher-flyd'
import {
  modelChanged
} from './common'

const proto = {
  name: 'Zoom',
  // injected: null,
  parseOptions,
  initLog,

  init() {
    return {
      url: null,
      show: false,
      content: null
    }
  },

  view(model) {
    // this.log.warn(`view called:`, { ...model })
    guard()
      // disabled for mobile. Change? Add config option?
      // .where(window.matchMedia("(min-width: 48em)").matches)
      .where(model.show === true)
      .do(() => {
        const popup = getWith('target', 'behaviors', 'Popup')(this)
        maybe(popup => {
          popup.show(this.dom.dataset.zoomClass)
        })(popup)
        // this.log.warn(`shown?`, popup)
      })
    model.show = false
    return model
  },

  update(msg, model) {
    // this.log.warn('update called', msg)
    model = {
      ...model
    }

    if (msg.type === 'click') {
      //   model.url = this.dom.dataset.uri
      model.show = true

      const name = this.dom.dataset.action
this.log.warn(`action:`, name)

this.log.warn(`dataset:`, {... this.dom.dataset})

      const handler = msg => {
// this.log.warn('zoom control: socket returned: ', msg)
        APIChannel.clear(name)

        model.content = msg.content

        const popup = getWith('target', 'behaviors', 'Popup')(this)
        maybe(popup => {
          popup.loadReponse(msg.content)
        })(popup)
      }

      const value = elem => (elem == null ? null : elem.dataset.value)

      // this.log.warn(`value: ${value(this.dom)}`)

      const ref = APIChannel.send(
        name, {
          value: value(this.dom),
          next: value(this.dom.nextElementSibling),
          last: value(this.dom.previousElementSibling),
          uri: this.dom.dataset.uri
        },
        handler
      )
      this.handlers[name] = ref
    }

    return model
  },

  initialize(dom) {
    this.dom = dom
    this.handlers = {}
    this.initLog()
    // this.log.warn("initializing:", this.dom)
    this.target = first(
      document
        .findByRole('popup')
        .filter(d => d.dataset.name === dom.dataset.target)
    )
    const popup = getWith('target', 'behaviors', 'Popup')(this)
    maybe(popup => {
      popup.setURL(this.dom.dataset.return)
    })(popup)

    // this.log.warn(`target:`, this.target)
    let currentModel = this.init()

    this.eventStream = new Stream()
    this.eventStream.map(msg => {
      let model = {
        ...currentModel
      }
      model = this.update(msg, model)
      if (modelChanged(currentModel, model)) {
        model = this.view(model)
      }
      currentModel = model
    })

    this.view(currentModel)
    this.dom.addEvent('click', this.eventStream.stream)

    // eslint-disable-next-line eqeqeq
    if (this.dom.dataset.onload != undefined) {
      // this.log.warn("onload:", this.dom.dataset.action)
      this.eventStream.stream({
        type: 'click'
      })
    }
  }
}

const Zoom = makeType(proto)

UI.register('zoom_control', Zoom)
